<template>
  <div class="wrapper">
    <div class="contentBox">
      <div class="searchBar">
        <el-form :inline="true">
          <el-form-item label="论文名称:">
            <el-input
              class="searchInput"
              size="small"
              placeholder="论文名称"
              v-model="searchCondition.paperName"
              clearable
            >
            </el-input>
          </el-form-item>
          <el-form-item label="考生姓名:"
            ><el-input
              class="searchInput"
              size="small"
              placeholder="考生姓名"
              v-model="searchCondition.userName"
              clearable
            >
            </el-input
          ></el-form-item>

          <el-form-item label="身份证:"
            ><el-input
              class="searchInput"
              size="small"
              placeholder="身份证"
              v-model="searchCondition.idCard"
              clearable
            >
            </el-input
          ></el-form-item>
          <el-form-item label="科目:"
            ><el-select
              v-model="searchCondition.testId"
              size="small"
              placeholder="科目"
            >
              <el-option
                value=""
                label="所有科目"
                key="'testSeachNone'"
              ></el-option>
              <el-option
                v-for="item in testList"
                :value="item.id"
                :label="item.testName"
                :key="'testSeach' + item.id"
              ></el-option> </el-select
          ></el-form-item>
        </el-form>

        <el-button
          type="primary"
          size="small"
          icon="el-icon-search"
          style="margin-top: 10px"
          @click="getPaperReviewList"
          >查询
        </el-button>
        <el-button
          type="info"
          size="small"
          style="margin-top: 10px"
          icon="el-icon-refresh-right"
          @click="resetSearchCondition"
          >重置
        </el-button>
      </div>

      <div class="tableContainer">
        <div class="actionBar">
          <el-button plain @click="exportData" size="small"> 导出 </el-button
          >&emsp;

          <el-dropdown trigger="click" class="reviewBar">
            <el-button type="primary" size="small">导出开题报告</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button
                  type="primary"
                  @click="downloadReport(false)"
                  size="mini"
                  :disabled="searchCondition.ids.length == 0"
                  >导出当前页勾选</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="primary"
                  @click="downloadReport(true)"
                  size="mini"
                  >导出此筛选所有记录</el-button
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          &emsp;

          <el-dropdown trigger="click" class="reviewBar">
            <el-button type="primary" size="small">一键下载论文</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button
                  @click="batchDownloadThesis(false)"
                  type="primary"
                  size="mini"
                  :disabled="searchCondition.ids.length == 0"
                  >下载当前页勾选</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  @click="batchDownloadThesis(true)"
                  type="primary"
                  size="mini"
                  :disabled="!searchCondition.testId"
                  >下载此筛选所有记录</el-button
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          &ensp;
        </div>
        <el-table
          :data="paperReviewList"
          @selection-change="
            (e) => {
              selectList = e;
            }
          "
          border
          style="width: 100%"
          ref="transformTable"
          :cell-style="{ padding: '8px 0', fontSize: '14px' }"
        >
          <el-table-column type="selection" width="40px" fixed>
          </el-table-column>
          <el-table-column prop="testName" label="考试名称" min-width="200px">
          </el-table-column
          ><el-table-column prop="paperName" label="论文名称" min-width="200px">
          </el-table-column
          ><el-table-column
            prop="reportName"
            label="开题报告"
            min-width="200px"
          >
          </el-table-column
          ><el-table-column prop="userName" label="提交人"> </el-table-column
          ><el-table-column prop="mobile" label="手机号"> </el-table-column
          ><el-table-column prop="submitNum" label="提交次数"> </el-table-column
          ><el-table-column prop="reviewStatus" label="审核状态">
          </el-table-column
          ><el-table-column prop="auditTeacher" label="审核人员">
          </el-table-column
          ><el-table-column prop="createTime" label="提交时间">
          </el-table-column>
          <el-table-column fixed="right" width="180px">
            <template slot-scope="{ row, index }">
              <div>
                <el-button
                  plain
                  size="mini"
                  class="bluBar"
                  @click="pdfShow(row)"
                  >预览
                </el-button>
                <el-button
                  size="mini"
                  class="bluBar"
                  @click="goToDetail('scoreThesis', row, 1)"
                  >审核
                </el-button>
                <el-button
                  size="mini"
                  class="bluBar"
                  @click="download(row.paperUrl)"
                  >下载
                </el-button>
                <!-- <el-button
                  size="mini"
                  class="bluBar"
                  @click="goToDetail('thesisAudit', row, 1)"
                  >详情
                </el-button> -->
              </div>
            </template></el-table-column
          >
          <!-- <el-table-column fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="editUser(scope.row)"
                >编辑</el-button
              >

              <el-button type="text" size="small" @click="deleteUser(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column> -->
        </el-table>

        <!--分页-->

        <el-row>
          <el-col :span="24">
            <div class="pagination">
              <el-pagination
                @size-change="getPaperReviewList"
                @current-change="getPaperReviewList"
                :current-page.sync="searchCondition.jumpPage"
                :page-sizes="[10, 30, 100]"
                :page-size.sync="searchCondition.pageSize"
                layout="total,sizes, prev, pager, next,jumper"
                :total="searchCondition.total"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      title="论文预览"
      :visible.sync="pdfData.pdfIfShow"
      width="70%"
      :append-to-body="true"
      top="2vh"
    >
      <pdf-preview :url="pdfData.pdfUrl" v-if="pdfData.pdfIfShow"></pdf-preview>
    </el-dialog>
  </div>
</template>

<script>
import {
  paperReviewExcelExport,
  getPaperApplyList,
  batchDownloadThesis,
  batchDownloadReport,
  getReviewSettings,
  getScoredThesis,
} from "@/api/paper.js";
import FileSave from "file-saver";
import Cookies from "js-cookie";
import pdfPreview from "@/views/my-components/other/pdf/pdfPreview.vue";

export default {
  data() {
    return {
      pdfData: {
        pdfUrl: null,
        pdfIfShow: false,
        currentPage: 1,
        totalPage: 0,
        pdfStream: null,
      },
      auditSettingData: {
        ifShow: false,
        isMultiple: 1,
        reviewNum: 1,
        distributionNum: 5,
      },
      roleCode: JSON.parse(Cookies.get("userInfo")).roles[0].code,
      downloadUrl: "../审核状态导入模板.xlsx",
      fileList: [],

      searchCondition: {
        pageSize: 100,
        jumpPage: 1,
        paperGroupName: "",
        reviewStatus: "",
        createTime: "",
        auditTeacher: "",
        paperName: "",

        ids: [],
        total: 0,
        idCard: "",
        userName: "",
      },

      paperReviewList: [],
      reviewOptions: [
        {
          value: 0,
          label: "审核不通过",
        },
        {
          value: 1,
          label: "审核通过",
        },
        {
          value: 2,
          label: "待审核",
        },
        {
          value: 3,
          label: "查重不合格",
        },
        {
          value: 4,
          label: "待查重",
        },
      ],
      testList: [],
    };
  },
  components: { pdfPreview },
  created() {},
  mounted() {
    getPaperApplyList({ source: 0 }).then((data) => {
      this.testList = data;
    });
    this.getPaperReviewList();
    getReviewSettings().then((data) => {
      this.auditSettingData = {
        ifShow: false,
        isMultiple: data.isMultiple,
        reviewNum: data.reviewNum,
        distributionNum: data.distributionNum,
      };
    });
  },
  methods: {
    downloadReport(ifAll) {
      let postData = {};
      if (ifAll) {
        Object.assign(postData, this.searchCondition);
        delete postData.ids;
      } else {
        postData = { ids: this.searchCondition.ids };
      }
      //批量下载
      batchDownloadReport(postData).then((data) => {
        let itemFiltered = data.filter((item) => item);
        itemFiltered.forEach((item) => {
          console.log(item.openQuestionReport);
          const response = {
            "content-disposition": `attachment; filename=${encodeURIComponent(
              item.reportName +
                "." +
                item.openQuestionReport.split(".")[
                  item.openQuestionReport.split(".").length - 1
                ]
            )}`,
          };
          // object-key表示从OSS下载文件时需要指定包含文件后缀在内的完整路径，例如abc/efg/123.jpg。
          const url = this.$oss.signatureUrl(
            decodeURI(item.openQuestionReport)
              .trim()
              .replace("https://cbsystem.oss-cn-shenzhen.aliyuncs.com/", ""),
            { response }
          );
          window.open(url);
        });
      });
    },

    resetSearchCondition() {
      Object.assign(this.searchCondition, this.$options.data().searchCondition);
    },
    pdfShow(row) {
      // var loadingTask = pdf.createLoadingTask(row.paperUrl);
      this.pdfData.pdfUrl = row.paperUrl;
      this.pdfData.pdfIfShow = true;
      // this.pdfData.pdfStream = loadingTask;
      // console.log(loadingTask);
    },

    goToDetail(routerName, item, e) {
      this.$router.push({
        name: routerName,
        query: { id: item.id, userId: item.userId, type: e },
      });
    },
    download(url) {
      var oReq = new XMLHttpRequest();
      oReq.open("GET", url, true);
      oReq.responseType = "blob";
      oReq.onload = function () {
        var file = new Blob([oReq.response], {
          type: "application/pdf",
        });
        // , `${row.userName}-${row.testName}-${row.id}.pdf`
        FileSave.saveAs(
          file,
          decodeURI(url.split("/")[url.split("/").length - 1])
        );
      };
      oReq.send();
    },
    getPaperReviewList() {
      console.log("筛选条件searchCondition=", this.searchCondition);
      getScoredThesis(this.searchCondition).then((data) => {
        console.log("paperSettingList结果", data);
        this.paperReviewList = data.records;
        this.searchCondition.total = data.total;
        this.searchCondition.ids = [];
      });
    },

    exportData() {
      paperReviewExcelExport(this.searchCondition)
        .then((data) => {
          this.$message.success("上传成功!");
          const pdfUrl = window.URL.createObjectURL(
            new Blob([data], {
              type: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`,
            })
          );
          const link = document.createElement("a");
          link.href = pdfUrl;
          link.setAttribute("download", "论文查重审核列表.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    batchDownloadThesis(ifAll) {
      this.$confirm(
        `本次操作将下载${
          ifAll ? this.searchCondition.total : this.searchCondition.ids.length
        }篇论文`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        let postData = ifAll
          ? this.searchCondition
          : { ids: this.searchCondition.ids };
        batchDownloadThesis(postData)
          .then((data) => {
            data.forEach((item) => {
              this.download(item.paperUrl);
            });

            console.log(data);
            // this.$message.success("一键下载成功");
            // this.getPaperReviewList();
          })
          .catch((err) => {
            this.error(data.message);
          });
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  font-size: 12px;

  .contentBox {
    padding: 20px;

    .searchBar {
      background: #fff;
      padding: 20px;
      margin-bottom: 15px;
    }

    //.lineStyle {
    //  overflow: scroll;
    //  width: 100%;
    //}

    .tableContainer {
      background: #fff;
      padding: 20px;

      .actionBar {
        padding-bottom: 10px;

        .reviewBar {
          float: right;
          margin-left: 10px;
        }
      }

      .bluBar {
        width: auto;
        color: #36aafd;
        border: 1px solid #36aafd;
        padding: 7px 10px;
        border-radius: 4px !important;
      }
    }
  }
}
.el-dropdown-menu__item {
  text-align: center;
}
/deep/ .ivu-table-cell {
  padding: 0 10px;
}
</style>
